import LogoImage from './logo.png';
import Logo2Image from './logo.svg';

export { LogoImage, Logo2Image };
